import { Navigate } from "react-router";
import { ROUTES } from "@/config/routes";
import { useAuthStore } from "@/store/authStore";
import type { ReactNode } from "react";

export function PublicRoute({ children }: { children: ReactNode }) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const restored = useAuthStore((state) => state.restored);

  if (!restored) {
    return null;
  }

  if (isAuthenticated) {
    return <Navigate to={ROUTES.profileCompletion} replace />;
  }

  return <>{children}</>;
}
